var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHelpRest(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "160px",
    viewBox: "0 0 240 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Help_rest") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Help_rest"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Frame_rest"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E2DDCD",
    x: 0,
    y: 0,
    width: 240,
    height: 156,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    x: 8,
    y: 7.8,
    width: 224,
    height: 140.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Help-LIbrary-Faint-Copy",
    transform: "translate(63.500000, 44.362500)",
    stroke: "#003256",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.6128,16.5874017 C53.4467113,16.5619681 53.2721702,16.5357284 53.0893431,16.508769 C51.6497116,16.2964833 50.0012639,16.0839153 48.1715985,15.8853606 C42.1167385,15.2282895 35.5939223,14.8787843 28.9217676,15.0000896 C22.3195671,15.1201268 15.8339276,15.6595219 9.7048826,16.4837144 C7.25219772,16.8135349 5.02730393,17.1667123 3.07210525,17.5195217 C2.62945079,17.5993973 2.2217399,17.6754938 1.8504,17.7470009 L1.8504,79.4909674 C3.60082221,78.3988079 5.61127019,77.3113637 7.86071067,76.295335 C13.7196745,73.6489545 20.1881469,71.9271959 27.1256353,71.5688864 C33.9934679,71.2141958 41.0614183,72.3351232 47.9001133,74.4185698 C49.9883315,75.0547571 51.9014423,75.736746 53.6003584,76.4198484 C53.6045089,76.4215172 53.6086561,76.4231853 53.6128,76.4248525 L53.6128,16.5874017 Z",
    id: "Clip-79",
    fill: "#CBD5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1072,16.5874017 L55.1072,76.4248525 C55.1113439,76.4231853 55.1154911,76.4215172 55.1196416,76.4198484 C56.8185577,75.736746 58.7316685,75.0547571 60.8198867,74.4185698 C67.6585817,72.3351232 74.7265321,71.2141958 81.5943693,71.5688867 C88.5318531,71.9271959 95.0003255,73.6489545 100.859289,76.295335 C103.10873,77.3113636 105.119178,78.3988078 106.8696,79.4909687 L106.8696,17.7470009 C106.49826,17.6754938 106.090549,17.5993973 105.647895,17.5195217 C103.692696,17.1667123 101.467802,16.8135349 99.0151174,16.4837144 C92.8860724,15.6595219 86.4004329,15.1201268 79.7982332,15.0000897 C73.1260777,14.8787843 66.6032615,15.2282895 60.5484015,15.8853606 C58.7187361,16.0839153 57.0702884,16.2964833 55.6306569,16.508769 C55.4478298,16.5357284 55.2732887,16.5619681 55.1072,16.5874017 Z",
    id: "Fill-81",
    fill: "#CBD5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.818857,9.30741263 C101.54737,9.07581091 101.231668,8.82082266 100.872661,8.54757019 C99.6704614,7.63253655 98.2514009,6.71391022 96.6269116,5.85492054 C91.9940288,3.40516682 86.67024,1.93112419 80.7284339,1.91973476 C74.958903,1.90871083 68.7529127,3.40786457 62.555705,5.9190918 C60.3845081,6.79890238 58.371062,7.74172958 56.568547,8.68346548 C56.0095313,8.97552695 55.5075831,9.24848061 55.0673251,9.49668028 L55.7730038,77.2399091 C55.8439244,77.1920736 55.9157379,77.1439017 55.9884411,77.0954041 C58.0942721,75.6906845 60.526208,74.2886647 63.2561594,72.9811036 C69.7494118,69.8710396 76.8869277,67.7792964 84.523156,67.1770141 C89.3391306,66.7971612 94.2343303,67.4250854 98.9089648,68.7021597 C99.916597,68.9774371 100.855696,69.2681577 101.716189,69.5629109 L101.818857,9.30741263 Z",
    id: "Fill-91",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90114259,9.30741263 L7.00381125,69.5629109 C7.86430369,69.2681577 8.80340304,68.9774371 9.81103522,68.7021597 C14.4856697,67.4250854 19.3808694,66.7971612 24.1968413,67.1770139 C31.8312701,67.7791543 39.0408038,69.8728547 45.6588714,72.985937 C48.4392623,74.2938091 50.9276515,75.6959708 53.0915436,77.1006015 C53.1908458,77.1650607 53.2885532,77.2289427 53.3846566,77.2922219 L53.6582107,9.49979977 C53.216626,9.25076969 52.7128131,8.97675179 52.151453,8.68346548 C50.348938,7.74172958 48.3354919,6.79890238 46.164295,5.9190918 C39.9670873,3.40786457 33.761097,1.90871083 27.9915752,1.91973474 C22.04976,1.93112419 16.7259712,3.40516682 12.0930884,5.85492054 C10.4685991,6.71391022 9.04953862,7.63253655 7.84733921,8.54757019 C7.48833168,8.82082266 7.17263036,9.07581091 6.90114259,9.30741263 Z",
    id: "Fill-86",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "circle-I-Copy",
    transform: "translate(158.000000, 23.400000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.84,0.936 C42.8928,0.936 54.72,12.46752 54.72,27.144 C54.72,41.82048 42.8928,53.352 27.84,53.352 C12.7872,53.352 0.96,41.82048 0.96,27.144 C0.96,12.46752 12.7872,0.936 27.84,0.936 Z",
    id: "Fill-96",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.84,0 C43.4304,0 55.68,11.94336 55.68,27.144 C55.68,42.34464 43.4304,54.288 27.84,54.288 C12.2496,54.288 0,42.34464 0,27.144 C0,11.94336 12.2496,0 27.84,0 Z",
    id: "Stroke-98",
    stroke: "#003256",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.84,8.424 C30.528,8.424 32.64,10.27728 32.64,12.636 C32.64,14.99472 30.528,16.848 27.84,16.848 C25.152,16.848 23.04,14.99472 23.04,12.636 C23.04,10.27728 25.152,8.424 27.84,8.424 Z",
    id: "Fill-99",
    fill: "#003256"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-100",
    fill: "#003256",
    points: "32.2863 24.0459375 32.2863 40.7679675 35.52 40.7679675 35.52 45.864 20.16 45.864 20.16 40.7679675 23.3937 40.768455 23.3937 24.024 20.16 24.024 20.16 19.656 23.3937 19.656 32.2863 19.656"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpRest);
export default __webpack_public_path__ + "static/media/Icon_Help_rest.949ea12a9efef7474c9f90ede578b9ee.svg";
export { ForwardRef as ReactComponent };